import ProviderManager from '../../../provider/providerManager';
import {
  FAULT_TYPE,
  hasActiveZoneFault,
  isPowerSupplyFaultDetected,
  shouldCheckZoneFaultStatus,
} from './problemDomainHelpers';

export const getInternetProducts = async () => {
  try {
    const providerData = await ProviderManager.getProviderData('getInternetProducts', {});
    if (providerData?.Body?.successResult?.isSuccess) {
      return providerData?.Body?.productsInfo || [];
    }
    return [];
  } catch (error) {
    console.log('getInternetProducts error');
    return [];
  }
};

export const getSubscribersByProductType = async (productType) => {
  try {
    const providerData = await ProviderManager.getProviderData('getSubscribersByProductType', [productType]);
    return providerData?.Body?.subscribers || providerData?.Body?.Subscribers || [];
  } catch (error) {
    console.log('getSubscribersByProductType error');
    return [];
  }
};

export const checkZoneFaultStatus = async (subscription, productWorld) => {
  try {
    if (!shouldCheckZoneFaultStatus(productWorld)) {
      return null;
    }

    const params = {
      ban: subscription?.raw?.ban || subscription?.ban,
      idNumber: subscription?.raw?.idNumber || subscription?.idNumber,
    };
    const result = await ProviderManager.getProviderData('getZoneFaultStatus', params);

    if (result?.Header?.ReturnCode === 0 && result?.Body?.successResult?.isSuccess) {
      return result.Body;
    }
    return null;
  } catch (error) {
    console.log('checkZoneFaultStatus error');
    throw error;
  }
};

export const checkPowerSupplyFault = async (subscription, productWorld) => {
  try {
    if (!shouldCheckZoneFaultStatus(productWorld)) {
      return null;
    }

    const ban = subscription?.raw?.ban || subscription?.ban;

    if (!ban) {
      return null;
    }

    const result = await ProviderManager.getProviderData('checkIsRecommendPowerSupply', [ban]);

    return result || null;
  } catch (error) {
    console.log('checkPowerSupplyFault error');
    throw error;

  }
};

export const detectFault = async (subscription, productWorld) => {
  const [zoneFault, powerSupplyFault] = await Promise.all([
    checkZoneFaultStatus(subscription, productWorld),
    checkPowerSupplyFault(subscription, productWorld),
  ]);

    if (hasActiveZoneFault(zoneFault)) {
      return {
        type: FAULT_TYPE.zone,
        data: zoneFault,
      };
  }

  if (isPowerSupplyFaultDetected(powerSupplyFault)) {
    return {
      type: FAULT_TYPE.powerSupply,
      data: powerSupplyFault,
      };
  }

  return {
    type: FAULT_TYPE.none,
    data: null,
  };
};
